import { FilterSetType } from '@statsbomb/parachute-types';
import { useAtomValue } from 'jotai';
import { useLocation } from 'react-router-dom';
import { dataLockerLandingPageSelectedTabAtom } from '@/atoms/dataLocker/landingPage';
import { DataLockerSelectedTab } from '@/types/tabs';

const tabFilterSetTypeMap = {
  [DataLockerSelectedTab.PLAYER]: FilterSetType.PLAYER_DATA_LOCKER,
  [DataLockerSelectedTab.TEAM]: FilterSetType.TEAM_DATA_LOCKER,
  [DataLockerSelectedTab.EVENTS]: FilterSetType.EVENT_DATA_LOCKER,
};

// determines which filter set type to use based on the current URL
export const useFilterSetType = () => {
  const { pathname } = useLocation();
  const dataLockerLandingPageSelectedTab = useAtomValue(dataLockerLandingPageSelectedTabAtom);

  if (pathname.includes('/data-locker/players')) return FilterSetType.PLAYER_DATA_LOCKER;
  if (pathname.includes('/data-locker/teams')) return FilterSetType.TEAM_DATA_LOCKER;
  if (pathname.includes('/data-locker/events')) return FilterSetType.EVENT_DATA_LOCKER;
  if (pathname.includes('/data-locker')) return tabFilterSetTypeMap[dataLockerLandingPageSelectedTab];
  return FilterSetType.FILTERS;
};
